import React from "react";
import { CheckCircle2, Clock } from "lucide-react";

interface HydrationStatusProps {
    hydrated?: boolean;
    enabled?: boolean;
    strategyName: string;
}

const HydrationStatus: React.FC<HydrationStatusProps> = ({ hydrated, enabled, strategyName }) => {
    if (!enabled) return null;

    return (
        <div className="flex items-center gap-2 px-2 py-1 rounded-full bg-white/5 border border-white/5 shadow-inner">
            {hydrated ? (
                <>
                    <CheckCircle2 size={12} className="text-emerald-400" />
                    <span className="text-[10px] font-bold text-emerald-400 uppercase tracking-tight">
                        {strategyName} Hydrated
                    </span>
                </>
            ) : (
                <>
                    <Clock size={12} className="text-amber-400 animate-spin-slow" />
                    <span className="text-[10px] font-bold text-amber-400 uppercase tracking-tight">
                        {strategyName} Hydrating...
                    </span>
                </>
            )}
        </div>
    );
};

export default HydrationStatus;
